export default {
    key: 'fc_id',
    set(id) {
        window.localStorage.setItem(this.key, id);
    },
    get() {
        return window.localStorage.getItem(this.key)
    },
    remove() {
        window.localStorage.removeItem(this.key)
    }
};